import React, { useEffect, useRef, useState } from 'react';
import { yen } from './VoiceCalculator';

function QuoteDialog({ text, onClose }) {
  const dialog = useRef(null);
  const content = useRef(null);
  const [copyStatus, setCopyStatus] = useState('');
  useEffect(() => {
    const previousFocus = document.activeElement;
    dialog.current.showModal();
    return () => previousFocus?.focus();
  }, []);
  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopyStatus('見積内容をコピーしました。');
    } catch {
      content.current.focus();
      content.current.select();
      setCopyStatus('コピーできませんでした。選択したテキストをコピーしてください。');
    }
  }
  return <dialog ref={dialog} className="voice-quote-dialog" aria-labelledby="voice-quote-title"
    onCancel={event => { event.preventDefault(); onClose(); }} onClose={onClose}>
    <h2 id="voice-quote-title">見積詳細</h2>
    <textarea ref={content} aria-label="見積内容（コピー用）" readOnly rows={17} value={text} />
    <div className="voice-actions">
      <button type="button" onClick={copy}>テキストをコピー</button>
      <button type="button" className="voice-secondary-button" onClick={onClose}>閉じる</button>
    </div>
    <p role="status">{copyStatus}</p>
  </dialog>;
}

export default function VoiceQuoteDetails({ job, quote, availability }) {
  const [open, setOpen] = useState(false);
  const text = quote ? [
    '朗読本文',
    '-------------',
    job.text,
    '-------------',
    '',
    '朗読のお見積り',
    `案件：${job.title || job.label}`,
    `1文字あたりの単価（税抜）：${yen(quote.rate)}`,
    `対象文字数（全体）：${quote.count.toLocaleString('ja-JP')}文字`,
    `基本朗読料（税抜）：${quote.count.toLocaleString('ja-JP')}文字 × ${yen(quote.rate)} ＝ ${yen(quote.base)}（円未満切捨て）`,
    `バイノーラル収録：${quote.extra ? 'あり' : 'なし'}（税抜加算 ${yen(quote.extra)}）`,
    `朗読動画：${quote.videoExtra ? 'あり・顔出し不要／体の撮影必須／編集・カット前の音声の元データを必ず提出' : 'なし'}（税抜加算 ${yen(quote.videoExtra)}）`,
    `チップ（税抜）：${yen(quote.tip)}`,
    `小計（税抜）：${yen(quote.subtotal)}`,
    `消費税（10％）：${yen(quote.consumptionTax)}`,
    `報酬総額（税込）：${yen(quote.gross)}`,
    `源泉徴収額：${yen(quote.tax)}`,
    `源泉徴収の適用：${quote.withholding ? 'あり' : 'なし'}`,
    `差引受取額：${yen(quote.net)}`,
    `納品可能日（希望する納期）：${availability || '未入力'}`,
    '',
    '文字数は料金計算の対象文字数です。英字・数字・句読点（「」『』を含む）も対象です。括弧内の注記・空白・改行・絵文字・句読点以外の記号は除外しています。',
    '源泉徴収額は国内居住の個人への報酬を想定した概算です。単価・オプション・チップの税抜合計に消費税10％（円未満切り捨て）を加算します。源泉徴収は税込総額を対象に計算します。',
    '正式な報酬・納期・納品形式・利用範囲・支払時期は、ご依頼前に個別に合意します。',
  ].join('\n') : '';
  return <>
    <button type="button" className="voice-secondary-button" disabled={!quote} aria-haspopup="dialog" onClick={() => setOpen(true)}>見積詳細を見る</button>
    {open && quote && <QuoteDialog text={text} onClose={() => setOpen(false)} />}
  </>;
}
